import { svg } from 'lit';

const symbol = svg`<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5 5L8 11.5 1.4 5" stroke="currentcolor" stroke-linecap="square"/></svg>`;

export { symbol as default };
